function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SecurityIcon from "@mui/icons-material/Security";
import PersonIcon from "@mui/icons-material/Person";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useCurrentGroupContext } from "../../contexts/CurrentGroupContext";
import { postGroupMember, deleteGroupMember } from "../../../../actions";
import { hasRole, roleIds } from "../../../../constants";
var tKey = "features.Chat.Actions.GroupMemberListItem";
function GroupMemberListItem(props) {
  var groupMember = props.groupMember;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCurrentGroupConte = useCurrentGroupContext(),
    currentGroup = _useCurrentGroupConte.currentGroup;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUserMember = currentGroup.members.find(function (member) {
    return member.user.id === authUserId;
  });
  var adminMembers = currentGroup.members.filter(function (member) {
    return hasRole(member, roleIds.ADMIN);
  });
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    optionsAnchorEl = _useState2[0],
    setOptionsAnchorEl = _useState2[1];
  var optionsOpen = Boolean(optionsAnchorEl);
  function handleOptionsClick(event) {
    setOptionsAnchorEl(event.currentTarget);
  }
  function handleClickRemoveAdminRole() {
    groupMember.roleIds = groupMember.roles.filter(function (role) {
      return role.name !== roleIds.ADMIN;
    }).map(function (role) {
      return role.id;
    });
    dispatch(postGroupMember(groupMember));
  }
  function handleClickAddAdminRole() {
    groupMember.roleIds = [].concat(_toConsumableArray(groupMember.roles.map(function (role) {
      return role.id;
    })), [roleIds.ADMIN]);
    dispatch(postGroupMember(groupMember));
  }
  function handleClickDelete() {
    groupMember.deletedById = authUserId;
    dispatch(deleteGroupMember(groupMember));
  }
  var forwardProps = function (_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return rest;
  }(props);
  var menuItems = [];
  hasRole(authUserMember, roleIds.ADMIN) && hasRole(groupMember, roleIds.ADMIN) && groupMember.user.type !== "AiUser" && adminMembers.length > 1 && menuItems.push(/*#__PURE__*/React.createElement(MenuItem, {
    dense: true,
    onClick: handleClickRemoveAdminRole
  }, t("".concat(tKey, ".removeAdminRole"))));
  hasRole(authUserMember, roleIds.ADMIN) && !hasRole(groupMember, roleIds.ADMIN) && groupMember.user.type !== "AiUser" && menuItems.push(/*#__PURE__*/React.createElement(MenuItem, {
    dense: true,
    onClick: handleClickAddAdminRole
  }, t("".concat(tKey, ".addAdminRole"))));
  hasRole(authUserMember, roleIds.ADMIN) && authUserId !== groupMember.user.id && menuItems.push(/*#__PURE__*/React.createElement(MenuItem, {
    dense: true,
    onClick: handleClickDelete
  }, t("".concat(tKey, ".removeFromGroup"))));
  (hasRole(authUserMember, roleIds.ADMIN) && adminMembers.length > 1 || !hasRole(authUserMember, roleIds.ADMIN)) && authUserId === groupMember.user.id && menuItems.push(/*#__PURE__*/React.createElement(MenuItem, {
    dense: true,
    onClick: handleClickDelete
  }, t("".concat(tKey, ".leaveGroup"))));
  return /*#__PURE__*/React.createElement(ListItem, forwardProps, /*#__PURE__*/React.createElement(ListItemIcon, null, hasRole(groupMember, roleIds.ADMIN) ? /*#__PURE__*/React.createElement(SecurityIcon, null) : /*#__PURE__*/React.createElement(PersonIcon, null)), /*#__PURE__*/React.createElement(ListItemText, {
    primary: groupMember.user.fullName,
    secondary: /*#__PURE__*/React.createElement(React.Fragment, null, hasRole(groupMember, roleIds.ADMIN) ? t("".concat(tKey, ".admin")) : "")
  }), menuItems.length > 0 && /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleOptionsClick
  }, /*#__PURE__*/React.createElement(MoreHorizIcon, null)), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: optionsAnchorEl,
    id: "options-menu",
    open: optionsOpen,
    onClose: function onClose() {
      return setOptionsAnchorEl(null);
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, menuItems)));
}
export default GroupMemberListItem;
GroupMemberListItem.propTypes = {
  groupMember: PropTypes.object.isRequired
};